import { render, staticRenderFns } from "./TotalResultView.vue?vue&type=template&id=1408b907&scoped=true&"
import script from "./TotalResultView.vue?vue&type=script&lang=ts&"
export * from "./TotalResultView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1408b907",
  null
  
)

export default component.exports